import space from '@styled-system/space'
import { em, math } from 'polished'
import styled, { css } from 'styled-components'

import { Col, Row } from 'styles/components/layout'
import { TextLH } from 'styles/components/typography'

export const RowStyled = styled(Row)`
  position: relative;
  padding-top: ${em(20)};
  padding-bottom: ${em(20)};

  ${p => p.theme.mq.upMd} {
    padding-top: ${em(20)};
    padding-bottom: ${em(20)};
    flex-wrap: nowrap;
    min-height: ${p =>
      math(
        `${p.theme.typography.textMedium} * ${p.theme.typography.textMediumLh} * 2`,
      )};
  }
`

export const TitleBlock = styled(Col)`
  position: relative;

  ${p => p.theme.mq.upMd} {
    position: static;
    display: flex;
    flex-direction: column;
    align-items: start;
  }

  ${p => p.theme.mq.upLg} {
    position: relative;
  }

  ${({ centered }) =>
    centered &&
    css`
      ${p => p.theme.mq.upMd} {
        align-items: center;
      }
    `}
`

export const Title = styled.div`
  max-width: ${em(270)};
  margin-bottom: ${em(8)};

  ${p => p.theme.mq.upMd} {
    margin-bottom: 0;
  }
`

export const TextLHStyled = styled(TextLH)`
  display: block;
  font-size: ${p => p.theme.typography.fontSizeXs};
  line-height: ${p => p.theme.typography.cartItemFontLh};
  color: ${p => p.theme.colors.blackOp4};

  ${p => p.theme.mq.upMd} {
    line-height: ${p => p.theme.typography.cartItemFontLhMd};
  }
`

export const Subtitle = styled.div`
  margin-top: ${em(1)};
`

const layoutBlock = css`
  position: relative;

  ${({ centered }) =>
    centered &&
    css`
      ${p => p.theme.mq.upMd} {
        display: flex;
        align-items: center;
      }
    `}

  ${({ isWideOnMobile }) =>
    isWideOnMobile &&
    css`
      ${p => p.theme.mq.downMd} {
        flex-basis: 100%;
        max-width: 100%;
      }
    `}
`

export const CostBlock = styled(Col)`
  ${layoutBlock};
`

export const DescBlockWrapper = styled(Col)`
  visibility: ${p => (p.isHidden ? 'hidden' : 'visible')};
  button {
    pointer-events: ${p => (p.isHidden ? 'none' : 'all')};
  }
`

export const DescBlock = styled(DescBlockWrapper)`
  ${space};
  ${layoutBlock};
`

export const ToggleBlock = styled.div`
  display: flex;
  margin-top: 20px;
  > div {
    margin-right: 10px;
  }
`

export const ToggleBlockText = styled.div`
  > div {
    display: inline-block;
    &:nth-child(1) {
      margin-right: 10px;
    }
  }
`

export const ToggleDescription = styled.div`
  > span {
    color: ${p => p.theme.colors.purpleHeartDark};
  }
`

export const ReadMoreLink = styled.div`
  color: ${p => p.theme.colors.pink};
  transition: opacity 0.3s ease-in-out;
  cursor: pointer;
  :hover {
    opacity: 0.5;
  }
`
